import { evidenceList } from '@/mocks/home';

export default function EvidenceSection() {
  return (
    <section id="evidence" className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <div className="mb-8 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="mb-2 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fingerprint-line text-lg" />
              </span>
              <span className="text-sm font-medium tracking-wide text-primary-700">实锤现场</span>
            </div>
            <h3 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">证据一条条摆出来，自己判断</h3>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
              视频、截图、录音、时间线——我们把能核对的原始材料集中陈列，尽量少下结论，把细节交给你。
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            <span className="rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-900">共 6 组材料</span>
            <span className="rounded-full bg-accent-100 px-3 py-1.5 text-xs text-accent-900">持续追加中</span>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {evidenceList.map((item) => (
            <article
              key={item.id}
              className="group cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-44 w-full overflow-hidden md:h-48">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`黑料大瓜 实锤 ${item.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-foreground-950/80 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h4 className="text-base font-bold text-foreground-900 transition-colors group-hover:text-primary-600">{item.title}</h4>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-eye-line" />
                    {item.stat}
                  </span>
                  <span className="flex items-center gap-1 text-primary-600">
                    查看详情
                    <i className="ri-arrow-right-s-line" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}